module.exports = __webpack_public_path__ + "img/20007.8eaddbc5.png";